import AdvanceGroupsList from './AdvanceGroupsList';

export default AdvanceGroupsList;
